import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const CheckedDocument: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45 45"
      fill="none"
      transform={`rotate(${rotation ?? 0})`}
    >
      <path
        d="M27.6013 3.68115H11.0383C10.0621 3.68115 9.1259 4.06894 8.43565 4.75919C7.74539 5.44945 7.3576 6.38564 7.3576 7.36182V36.8071C7.3576 37.7833 7.74539 38.7195 8.43565 39.4098C9.1259 40.1 10.0621 40.4878 11.0383 40.4878H33.1223C34.0984 40.4878 35.0346 40.1 35.7249 39.4098C36.4151 38.7195 36.8029 37.7833 36.8029 36.8071V12.8828L27.6013 3.68115Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.68066"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M25.7645 3.68115V11.0425C25.7645 12.0187 26.1522 12.9548 26.8425 13.6451C27.5328 14.3354 28.469 14.7231 29.4451 14.7231H36.8065"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.68066"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.561 27.6045L20.2417 31.2852L27.603 23.9238"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.68066"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </IconWrapper>
);

CheckedDocument.displayName = 'CheckedDocument';
